import {z} from "zod/v4-mini"
import {graphNode} from "@cm/graph-v3"
import {registerTemplateGraphNode} from "#template/template-node/register"
import {pointGeometryAttributeSetLikeMarker} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import {PointGeometryProductOperatorPointGeometryPointGeometryInput} from "#template/nodes/geometry-graph/attribute-set/product-operator/point-geometry-product-operator-point-geometry-point-geometry-input"

import type {TemplateNodeDefinition} from "#template/template-node/types"
import {getTemplateNodeReturns} from "#template/template-node/validation"

import type {PointGeometryAttributeSetLikeNode} from "#template/nodes/geometry-graph/attribute-set/attribute-set-node"
import type {ProductOperatorParameters} from "#template/nodes/geometry-graph/attribute-set/product-operator/geometry-product-operator-node"
import {GeometryProductOperatorNode} from "#template/nodes/geometry-graph/attribute-set/product-operator/geometry-product-operator-node"

export type PointGeometryProductOperatorParameters = ProductOperatorParameters<PointGeometryProductOperatorPointGeometryPointGeometryInput>

const definition: TemplateNodeDefinition<PointGeometryProductOperatorParameters> = {
    nodeClass: "PointGeometryProductOperator",
    validation: {
        parameters: z.object({
            name: z.string(),
            operator: graphNode(PointGeometryProductOperatorPointGeometryPointGeometryInput),
        }),
        returns: getTemplateNodeReturns(),
    },
}

@registerTemplateGraphNode
export class PointGeometryProductOperator
    extends GeometryProductOperatorNode<0, PointGeometryProductOperatorPointGeometryPointGeometryInput>
    implements PointGeometryAttributeSetLikeNode
{
    get [pointGeometryAttributeSetLikeMarker]() {
        return true as const
    }

    public override get definition() {
        return definition
    }

    public override get availableInputClasses() {
        return [PointGeometryProductOperatorPointGeometryPointGeometryInput]
    }
}
